/**
* Version 0.100
* 
* Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
* Copyright 2016 - 2025.
* 
* !Changelog

* 	17-10-2018
* 	- [BORN] This class is born. Hooray!
* 
* !Usage
* 
*   - 
* 	
* !Wishlist
* 
* 	// none
* 	
*/

var specific_dogs_slideshow = {};

(function () {

	// DOCUMENT READY  *****************************************************************
	// DOCUMENT READY *****************************************************************
	// DOCUMENT READY ******************************************************************
	// DOCUMENT READY ******************************************************************

	this.onready = function () {

		/**
		 * Init slideshow
		 */
		var swiper = new Swiper('.js-dogs-slideshow', {

			loop: true,
			spaceBetween: 30,
			slidesPerView: 1,
			autoplay: {
				disableOnInteraction: false,
			},

			navigation: {
				nextEl: '.js-button-next',
				prevEl: '.js-button-prev',
			},

			// If we need pagination
			// pagination: {
			// 	el: '.swiper-pagination',
			// 	clickable: true,
			// },

			breakpoints: {
				1024: {
					slidesPerView: 3
				}
			}

		});

	};

	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************

	// none yet

}).apply(specific_dogs_slideshow);